import BaseCampaignOverviewSubjectsSubjectRoute from 'cio/pods/base/overview/subjects/subject/route';

export default class CampaignOverviewSubjectsSubjectRoute extends BaseCampaignOverviewSubjectsSubjectRoute {}
